import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/logo.png" alt="Heritage Hub Logo" className="footer-logo" />
            </div>
            <p>Traditional Attire, Timeless Adornments, Vernacular Stories — South Africa's Heritage in One Hub</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/products">Shop</a></li>
              <li><a href="/vendor-application">Become a Vendor</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: mashaba.enterprise2025@gmail.com</p>
            <p>Shipping Available Nationwide</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Heritage Hub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
